import { render, staticRenderFns } from "./ProductSingle.vue?vue&type=template&id=2312d7d4&scoped=true&"
import script from "./ProductSingle.vue?vue&type=script&lang=js&"
export * from "./ProductSingle.vue?vue&type=script&lang=js&"
import style0 from "./ProductSingle.vue?vue&type=style&index=0&id=2312d7d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312d7d4",
  null
  
)

export default component.exports